export function LoadingIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M2.23633 11C3.09687 13.8912 5.77258 16 8.94336 16C12.1141 16 14.7899 13.8912 15.6504 11H17.7158C16.8063 15.0076 13.2263 18 8.94336 18C4.66047 18 1.08043 15.0076 0.170898 11H2.23633Z"
        fill="currentColor"
      />
      <path
        d="M8.94336 0C13.2263 3.74422e-07 16.8063 2.9924 17.7158 7H15.6504C14.7899 4.10882 12.1141 2 8.94336 2C5.77258 2 3.09687 4.10882 2.23633 7H0.170898C1.08043 2.9924 4.66047 -8.01738e-09 8.94336 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
